<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 v-if="showTitle" class="mb-5">Hipotekos / Įkeitimai</h3>

    <pranesimas-perduoti-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchPerduoti"
    />

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.pranesimo_busena`]="{ item }">
        <el-hipoteka-busena :busena="item.pranesimo_busena" />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @duplicateItem="duplicateItem(item)"
          />
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="
          printData('pranesimas/perduoti/print', 'Perduoti dokumentai')
        "
        :disabled="canPrint"
        :loading="loading"
        >Spausdinti</el-button
      >
    </v-footer>

    <modal-confirm
      :title="modalConfirmTitle"
      :text="modalConfirmText"
      :action="modalConfirmAction"
      v-model="showConfirm"
      :item="modalConfirmItem"
      @confirmDuplicate="confirmDuplicate"
      @cancelConfirm="closeConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import PranesimasPerduotiSearch from './PranesimasPerduotiSearch'
import ModalConfirm from '../modals/ModalConfirm'
import print from '../../mixins/print'
import kurtiPagrindu from './kurtiPagrindu'

export default {
  name: 'PranesimasPerduoti',
  components: {
    PranesimasPerduotiSearch,
    ModalConfirm,
  },
  mixins: [print, kurtiPagrindu],
  props: {
    singleTab: Boolean,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      pranesimai: [],
      headers: [
        {
          text: 'Dokumento numeris',
          align: 'start',
          value: 'dokumento_numeris',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'identifikavimo_kodas_registre',
        },
        {
          text: 'Šalis (pirma)',
          align: 'start',
          value: 'skolininkai',
        },
        {
          text: 'Šalis (antra)',
          align: 'start',
          sortable: false,
          value: 'kreditoriai',
        },
        {
          text: 'Būsena',
          align: 'start',
          sortable: false,
          value: 'pranesimo_busena',
        },
        {
          text: 'Paskutinis pakeitimas',
          align: 'start',
          value: 'busenos_data',
        },
        {
          text: 'Paskutinis veiksmus atlikęs asmuo',
          align: 'start',
          value: 'pateikes_asmuo',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
    }
  },
  computed: {
    ...mapGetters(['listInfo']),

    filterItemList() {
      return this.pranesimai.map(pranesimas => {
        pranesimas.hipotekaTipas = HipotekaMap['hipotekaTipas'][
          pranesimas.pranesimo_rusis
        ]
          ? HipotekaMap['hipotekaTipas'][pranesimas.pranesimo_rusis].title
          : pranesimas.pranesimo_rusis
        pranesimas.skolininkai = pranesimas.skol_ir_gav.join(', ')
        pranesimas.kreditoriai = pranesimas.kred_ir_dav.join(', ')

        pranesimas.canEdit = false
        pranesimas.canView = true
        pranesimas.canDuplicate = pranesimas.galima_kurti_pagrindu

        if (pranesimas.zug_pasirasymas_vadovas) {
          if (
            (this.roleDT && pranesimas.zug_busena_tolimesne === 'perduotas') ||
            (this.roleRGV && pranesimas.zug_busena_tolimesne === 'atmestas')
          ) {
            pranesimas.showSign = true
          }
        }
        return pranesimas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
    showTitle() {
      return !this.singleTab
    },
  },
  created() {
    // this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`pranesimas/perduoti`, data)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchPerduoti(searchData) {
      this.searchData = searchData

      let resetPageNr = true
      if (this.$route.params.toList) {
        this.pagination = this.listInfo.pagination
        resetPageNr = false
        this.$route.params.toList = false
      }
      this.getData(resetPageNr)
    },
    editItem(item) {
      const objektasID = item.obj_id
      this.$store.dispatch('objektasID', objektasID)
      this.$store.dispatch('hipotekaTipas', item.pranesimo_rusis)
      // this.$store.dispatch('objektasVeiksmas', item.obj_veiksmas ?? 0)

      const listInfo = {
        obj_id: item.obj_id,
        routeName: 'perduotiDokumentaiHipoteka',
        pagination: this.pagination,
        search: this.searchData,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'hipotekaRegistravimas',
          params: {
            objektasID: objektasID,
          },
        })
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
